const mediaItems = [
  {
    title: '顶流男星深夜私会全程跟拍画面流出',
    duration: '12:35',
    views: '89.2万',
    tag: '独家',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20video%20thumbnail%20illustration%20with%20play%20button%2C%20night%20scene%20silhouettes%2C%20warm%20orange%20and%20dark%20coral%20gradient%2C%20modern%20minimal%20style%2C%20clean%20composition%2C%20cinematic%20atmosphere%2C%20editorial%20design&width=800&height=500&seq=media-01&orientation=landscape',
  },
  {
    title: '某剧组内部矛盾升级，工作人员匿名爆料录音',
    duration: '08:21',
    views: '56.7万',
    tag: '热播',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20film%20set%20illustration%20with%20audio%20waveform%2C%20warm%20amber%20and%20soft%20rose%20palette%2C%20modern%20flat%20design%2C%20clean%20geometric%20shapes%2C%20editorial%20composition%2C%20mysterious%20atmosphere&width=800&height=500&seq=media-02&orientation=landscape',
  },
  {
    title: '网红带货翻车现场完整回放，场面一度尴尬',
    duration: '15:42',
    views: '102.3万',
    tag: '热门',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20live%20streaming%20scene%20illustration%2C%20shopping%20elements%20with%20dramatic%20lighting%2C%20warm%20coral%20and%20cream%20gradient%2C%20modern%20minimal%20style%2C%20clean%20lines%2C%20editorial%20design&width=800&height=500&seq=media-03&orientation=landscape',
  },
  {
    title: '年度最离谱反转事件时间线完整梳理',
    duration: '20:08',
    views: '134.6万',
    tag: '爆款',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20timeline%20illustration%20with%20dramatic%20plot%20twists%2C%20warm%20orange%20and%20pink%20color%20scheme%2C%20arrow%20and%20path%20motifs%2C%20modern%20minimal%20art%2C%20clean%20composition%2C%20editorial%20style&width=800&height=500&seq=media-04&orientation=landscape',
  },
  {
    title: '娱乐圈十年恩怨大起底，谁能笑到最后',
    duration: '18:55',
    views: '78.4万',
    tag: '专题',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20versus%20and%20rivalry%20illustration%2C%20split%20composition%20with%20warm%20coral%20and%20rose%20tones%2C%20modern%20flat%20design%2C%20clean%20geometric%20shapes%2C%20editorial%20style%2C%20dramatic%20yet%20minimal&width=800&height=500&seq=media-05&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">
            黑料视频专区
          </h2>
          <p className="text-sm md:text-base text-foreground-500">
            高清流畅，海量黑料在线播放
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {mediaItems.slice(0, 3).map((item, i) => (
            <div
              key={i}
              className="group bg-background-50 border border-background-200/50 rounded-xl overflow-hidden hover:border-secondary-200/50 transition-all duration-300 cursor-pointer"
            >
              <div className="relative w-full h-48 md:h-52 overflow-hidden bg-background-100">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  width="800"
                  height="500"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.style.display = 'none';
                  }}
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-background-50/90 flex items-center justify-center group-hover:scale-110 transition-transform cursor-pointer">
                    <i className="ri-play-fill text-2xl text-primary-500 ml-0.5"></i>
                  </div>
                </div>
                <span className="absolute top-3 left-3 px-2 py-0.5 rounded bg-secondary-500 text-background-50 text-xs font-medium">
                  {item.tag}
                </span>
                <span className="absolute bottom-3 right-3 px-2 py-0.5 rounded bg-foreground-950/70 text-background-50 text-xs">
                  {item.duration}
                </span>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-sm md:text-base text-foreground-900 mb-2 line-clamp-2 group-hover:text-secondary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-400 flex items-center gap-1">
                  <i className="ri-eye-line"></i>
                  {item.views} 次观看
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 md:gap-6 mt-5 md:mt-6">
          {mediaItems.slice(3).map((item, i) => (
            <div
              key={i + 3}
              className="group bg-background-50 border border-background-200/50 rounded-xl overflow-hidden hover:border-secondary-200/50 transition-all duration-300 cursor-pointer"
            >
              <div className="flex flex-col sm:flex-row">
                <div className="relative w-full sm:w-56 h-40 sm:h-36 overflow-hidden bg-background-100 flex-shrink-0">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    width="800"
                    height="500"
                    onError={(e) => {
                      const target = e.currentTarget;
                      target.style.display = 'none';
                    }}
                  />
                  <div className="absolute inset-0 flex items-center justify-center">
                    <div className="w-10 h-10 rounded-full bg-background-50/90 flex items-center justify-center group-hover:scale-110 transition-transform cursor-pointer">
                      <i className="ri-play-fill text-xl text-primary-500 ml-0.5"></i>
                    </div>
                  </div>
                  <span className="absolute bottom-2 right-2 px-1.5 py-0.5 rounded bg-foreground-950/70 text-background-50 text-xs">
                    {item.duration}
                  </span>
                </div>
                <div className="flex-1 p-4 flex flex-col justify-center">
                  <span className="inline-block px-2 py-0.5 rounded bg-secondary-100 text-secondary-700 text-xs font-medium mb-2 w-fit">
                    {item.tag}
                  </span>
                  <h3 className="font-heading text-sm md:text-base text-foreground-900 mb-2 group-hover:text-secondary-500 transition-colors line-clamp-2">
                    {item.title}
                  </h3>
                  <p className="text-xs text-foreground-400 flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {item.views} 次观看
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}